<template>
  <div styleName="app">
    <Home />
    <RoomStartCountdown :isShow="isShowModal" />
  </div>
</template>
<script>
import cssModules from 'vue-css-modules'
import Home from '@/views/Home'
import RoomStartCountdown from '@/views/RoomStartCountdown'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as types from '@/constants'
// import { SENSORLOG } from '@/constants'
import sensorLog from '@/utils/sensorLog'
import axios from '@/api/index'

const TIMETOPLAYBACK = 1 * 60 * 60 * 1000 // 回放生成时间

export default {
  name: 'index',
  mixins: [cssModules()],
  components: {
    Home,
    RoomStartCountdown
  },
  computed: {
    ...mapGetters(['roomDetail', 'webseverData', 'isShowModal', 'enterRoomParams']),
    lessonName () {
      return this.roomDetail.data.lessonName
    }
  },
  created () {
    this.chekRoomType()
  },
  mounted () {
    // 修改title
    document.title = this.lessonName
  },
  methods: {
    ...mapActions([
      'fetchWebserverData',
      'fetchEnterRoomParams',
      'fetchSignalSDK'
    ]),
    ...mapMutations([types.UPDATA_ENTER_ROOM_STATUS, types.UPDATA_ISSHOW_MODAL]),
    chekRoomType () {

      // 获取房间类型1多贝，2声网，3mbs
      this.fetchEnterRoomParams().then(() => {
        let {
          roomType,
          roomURL,
          isPlayback,
        } = this.enterRoomParams
        this.roomType = roomType
        this.isPlayback = isPlayback
        sensorLog.track("check_room_type", types.SENSORLOG.type.SUCCESSED, JSON.stringify({ roomType, isPlayback }))
        if (isPlayback === 0) {
          // 标准上课
          if (roomType === 1 || roomType === 3) {
            // 声网教室和mbs
            this.checkScheTimer()
          } else {
            // 多贝教室
            window.location.href = roomURL
          }
        } else {
          // 回放地址
          window.location.href = roomURL
        }
      }).catch((err) => {
        if (Object.keys(err).length === 0 || err === null) {
          err = 'something error! please refresh again!'
        }
        this.$toast.show({
          text: err,
          headerDesc: this.$t('attention'),
          buttonCount: 1,
          textStyle: {
            textAlign: 'center'
          },
          btnText: this.$t('btnok'),
          btnOK: () => {
            window.location.reload()
          }
        })
        sensorLog.track("check_room_type", types.SENSORLOG.type.FAILED, err)
      })
    },
    async checkScheTimer () {
      let { data } = this.roomDetail
      let serverTime = await this.getServerTime(data.serverTime)
      let { scheduleTime, duration } = data
      if (scheduleTime - serverTime >= 5 * 24 * 3600 * 1000) {
        // 大于5天
        this[types.UPDATA_ISSHOW_MODAL](true)
        this[types.UPDATA_ENTER_ROOM_STATUS]('BEFORE_CLASS')
        sensorLog.track("check_room_time", types.SENSORLOG.type.SUCCESSED, 'BEFORE_CLASS')
      } else if (process.env.NODE_ENV === 'production' && (serverTime - scheduleTime >= duration * 1000 + TIMETOPLAYBACK)) {
        // 上课时间超过1小时，自动下课
        this[types.UPDATA_ISSHOW_MODAL](true)
        this[types.UPDATA_ENTER_ROOM_STATUS]('AFTER_CLASS')
        sensorLog.track("check_room_time", types.SENSORLOG.type.SUCCESSED, 'AFTER_CLASS')
      } else {
        this.fetchWebserverData()
          .then(() => {
            let { data } = this.webseverData
            let { authInfo } = data
            if (authInfo) {
              this.fetchSignalSDK(authInfo)
            }
            sensorLog.track("fetch_webserver", types.SENSORLOG.type.SUCCESSED, JSON.stringify(data))
          }).catch((err) => {
            if (Object.keys(err).length === 0 || err === null) {
              err = 'something error! please refresh again!'
            }
            // fetchWebserverData失败只有校验失败这种情况
            this.$toast.show({
              text: err,
              headerDesc: this.$t('attention'),
              buttonCount: 1,
              btnText: this.$t('btnok'),
              textStyle: {
                textAlign: 'center'
              },
              btnOK: () => {
                window.location.reload()
              }
            })
            sensorLog.track("fetch_webserver", types.SENSORLOG.type.FAILED, 'token校验失败')
          })
      }
    },
    async getServerTime (candidate) {
      let res, serverTime
      try {
        res = await axios.getServerTime()
        serverTime = res.nowtime
        sensorLog.track("get_server_time", types.SENSORLOG.type.SUCCESSED, serverTime)
      } catch (e) {
        try {
          res = await axios.getServerTime()
          serverTime = res.nowtime
        } catch (e) {
          sensorLog.track("get_server_time", types.SENSORLOG.type.FAILED, e)
          serverTime = candidate
        }
      }
      return serverTime
    }
  }
}
</script>

<style module>
.app {
  width: 100%;
  height: 100%;
}
</style>
